import {Box, Grid, TextField, Typography} from "@material-ui/core";
import * as React from "react";
import {useEffect, useState} from "react";
import './Profile.css'
import ChangePassword from "../../component/ChangePassword/ChangePassword";
import {useAuthState} from "../../context/AuthContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {ProfileService} from "./ProfileService";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";

const Profile = () => {
    const token = useAuthState().token
    const snackbar = useSnackbarDispatcher()
    const loading = useLoadingDispatcher()
    const service = new ProfileService(token, snackbar, loading)

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getManagerInfo()
        }
    }, [])

    function getManagerInfo() {
        loading(setLoadingStateDispatch(true))
        service.getManagerProfileInfo()
            .then(response => {
                setName(response.firstName)
                setLastName(response.lastName)
                setUserName(response.username)
                setPhoneNumber(response.phoneNumber)
                setNationalCode(response.nationalCode)

                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            loading(setLoadingStateDispatch(false))
        })
    }


    const [openDialog, setOpenDialog] = useState(false);

    const handleClickOpen = () => {
        setOpenDialog(true);
    };
    const handleClose = () => {
        setOpenDialog(false);
    };
    // state-start
    const [name, setName] = useState('')
    const [lastName, setLastName] = useState('')
    const [userName, setUserName] = useState('')
    const [nationalCode, setNationalCode] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')

    // state-end

    function refreshProfile() {
        if (checkFieldConditions()) {
            service.changeManagerProfileInfo(
                service.prepareManagerProfileData(
                    name, lastName, userName, nationalCode, phoneNumber
                ))
        }
    }

    function checkFieldConditions() {
        let state = true
        let message = ""
        if (name.trim().length <= 0) {
            state = false
            message = "نام کاربر وارد نشده است!"
        } else if (lastName.trim().length <= 0) {
            state = false
            message = "نام خانوادگی کاربر وارد نشده است!"
        } else if (userName.trim().length <= 0) {
            state = false
            message = "نام کاربری باید حداقل 8 حرف داشته باشد!"
        } else if (nationalCode.trim().length < 8 || nationalCode.trim().length > 10) {
            state = false
            message = "شماره شناسنامه وارد شده صحیح نمی باشد!"
        } else if (phoneNumber.trim().length !== 11) {
            state = false
            message = "شماره همراه وارد شده صحیح نمی باشد!"
        }

        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        return state
    }


    return (
        <>


            {
                <ChangePassword
                    openDialog={openDialog}
                    handleClose={handleClose}

                />
            }
            <section className="pageContainer mt-sm-3">
                <Box className="accountDetailsHeader">
                    <section className="accountDetailsHeader-title">
                        <Typography variant={"h5"}>
                            جزئیات حساب
                        </Typography>
                    </section>
                    <section className="account-details-header-button-section">
                        <button className="btn-secondary" onClick={handleClickOpen}>تغییر کلمه عبور</button>
                        <button className="btn-confirm" style={{marginRight: "1rem"}}
                                onClick={_ => refreshProfile()}>بروزرسانی
                        </button>
                    </section>
                </Box>

                <Box className="flex-grow-1 w-100" sm={12}>
                    <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12} style={{marginTop: '1rem'}}>
                        <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                            <TextField className='w-100' variant="outlined" label="نام"
                                       value={name}
                                       onChange={e => {
                                           setName(e.target.value)
                                       }}/>
                        </Grid>
                        <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                            <TextField className='w-100' variant="outlined" label="نام خانوادگی"
                                       value={lastName}
                                       onChange={e => {
                                           setLastName(e.target.value)
                                       }}/>
                        </Grid>
                        <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                            <TextField className='w-100' variant="outlined" label="نام کاربری"
                                       value={userName} onChange={e => {
                                setUserName(e.target.value)
                            }}/>
                        </Grid>
                        <Grid sm={6} md={6} lg={6} xl={6} className='p-2 w-100'>
                            <TextField className='w-100' variant="outlined" label="کد ملی"
                                       value={nationalCode} onChange={e => {
                                setNationalCode(e.target.value)
                            }}/>
                        </Grid>
                        <Grid sm={12} md={6} lg={6} xl={6} className='p-2 w-100'>
                            <TextField className='w-100' variant="outlined" label="شماره همراه"
                                       value={phoneNumber} onChange={e => {
                                setPhoneNumber(e.target.value)
                            }}/>
                        </Grid>
                    </Grid>
                </Box>

            </section>
        </>

    )
}
export default Profile;
